import SurveysService from "@/services/SurveysService";
import AdministrationService from "@/services/AdministrationService";
import DashboardService from "@/services/DashboardService-bmw";
import EventBus from "@/services/EventBus";

export default {
  namespaced: true,

  state: {
    clients: [],
    structure: {},
    structures: [],
    isClientReady: false,
    appLoading: false,
    brandIds: [],
    countryCodes: [],
    filters: undefined,
  },

  getters: {
    appLoading: state => state.appLoading,
    clients: state => state.clients || [],
    brandIds: state => state.brandIds,
    countryCodes: state => state.countryCodes,
    filters: state => state.filters,
    isClientReady: state => state.isClientReady,
    project: state => {
      const firstChild = state.structure.children?.[0];
      return firstChild?.id?.startsWith('P') ? firstChild : null;
    },
    structure: state => state.structure,
    structures: state => state.structures,
    surveyIds: state => {
      if (!state.isClientReady) return [];
      if (state.structure && state.structure.children[0]?.id.startsWith('P')) {
        if (!state.structure.children[0].children) return [];
        return state.structure.children[0].children.map(project => project.Survey.SurveyId);
      }
      return state.structure.children.map(survey => survey.Survey.SurveyId);
    },
  },

  mutations: {
    SET_BRANDIDS(state, brandIds) {
      state.brandIds = brandIds;
    },
    SET_CLIENTS(state, clients) {
      state.clients = clients;
    },
    SET_COUNTRYCODES(state, countryCodes) {
      state.countryCodes = countryCodes;
    },
    SET_FILTERS(state, filters) {
      state.filters = filters;
    },
    SET_ISCLIENTREADY(state, isClientReady) {
      const wasReady = state.isClientReady;
      state.isClientReady = isClientReady;
      if (!wasReady && isClientReady) {
        EventBus.$emit('app.ready');
      }
    },
    SET_APPLOADING(state, appLoading) {
      state.appLoading = appLoading;
    },
    SET_STRUCTURE(state, structure) {
      state.structure = structure;
    },
    SET_STRUCTURES(state, structures) {
      state.structures = structures;
    },
  },

  actions: {
    setAppLoading({ commit }, appLoading) {
      commit('SET_APPLOADING', appLoading);
    },
    async fetchClients({ commit, dispatch }) {
       AdministrationService.getClientSettings(null)
        .then(response => {
          commit('SET_CLIENTS', response.data);
        })
        .catch(error => {
          log.error("Error while receiving client settings: " + error);
          this.isBusy = false;
        });
    },

    async fetchStructure({ commit, state, rootGetters }) {
      if(state.structure && state.structure.id)
        return;

      commit('SET_ISCLIENTREADY', false);
      const localizationId = rootGetters['auth/localizationId'];
      const clientId = rootGetters['auth/clientId'];
      const structures = await SurveysService.getSurveyStructure(
        localizationId, false, false);
      commit('SET_STRUCTURES', structures.data);

      commit('SET_STRUCTURE',
        structures.data.find(x => x.id === `C${clientId}`) || undefined);
      commit('SET_ISCLIENTREADY', true);
    },

    async fetchFilters({ commit, state, rootGetters }) {
      if (state.filters)
        return;
      const localizationId = rootGetters['auth/localizationId'];

      const emptyFilters = await DashboardService.getOptions(
        { api: '2021' }, null, localizationId);
      const clientId = emptyFilters.data[0]._visuals[0].ClientBmw;
      commit('auth/SET_CLIENT_ID', clientId, { root: true });

      const brandIds = emptyFilters.data[0].Brand[0].children.flatMap(brandGroup => {
        return brandGroup.children.map(brand => brand.id.substring(1));
      });
      commit('SET_BRANDIDS', brandIds);

      DashboardService.getOptions(
        { api: '2021', brand: brandIds.join('|')  }, null, localizationId
      ).then(filters => {
        const countryCodes = [...new Set(
          filters.data[0].ClientLocations.map(location =>
            location.label.substring(0, 2)
          )
        )];
        commit('SET_COUNTRYCODES', countryCodes);
        commit('SET_FILTERS', filters.data[0]);
      }).catch(() => {
        log.error("Failed to load country codes AND FILTERS");
      });
    }
  },
};
